import React, { Component } from "react"



export class FormTable extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount(){
    }

    render() {
        return (
            <tr className="odd">
                <td>{"transaction_number"}</td>
                <td>{"amount"}</td>
                <td>{"date"}</td>
                <td>{"date"}</td>
                <td>{"date"}</td>
            </tr>
        )

    }

}
